<template>
	<div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 800px">
		<div>
			<loading />
			<p style="font-weight: bold; text-align: center;">Your session is expired. <br>Redirecting to home page...</p>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
			}
		},
		created() {

			setTimeout(() => {
				window.location.replace(this.config.redirect_url);
			}, 2000)

			
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Expired.vue